import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, UserCheck, FileSignature, Scale, AlertTriangle, Briefcase, ShieldAlert, Unlock, HeartCrack, Users, Baby, ScrollText, Gavel, History } from 'lucide-react';
const tabs = [{
  id: 'military',
  label: 'Військове право'
}, {
  id: 'bankruptcy',
  label: 'Банкрутство'
}, {
  id: 'family',
  label: 'Сімейне право'
}, {
  id: 'inheritance',
  label: 'Спадкове право'
}];
const servicesData = {
  military: [{
    icon: <FileText size={24} strokeWidth={1.5} data-id="element-134" />,
    title: 'Оскарження рішень ВЛК',
    description: 'Юридичний супровід процедури оскарження висновків військово-лікарської комісії в ЦВЛК або суді.',
    price: 'від 3000 грн'
  }, {
    icon: <UserCheck size={24} strokeWidth={1.5} data-id="element-135" />,
    title: 'Супровід у ТЦК та СП',
    description: 'Фізичний та дистанційний супровід адвоката. Захист від неправомірних дій та примусової мобілізації.',
    price: 'від 4000 грн'
  }, {
    icon: <FileSignature size={24} strokeWidth={1.5} data-id="element-136" />,
    title: 'Оформлення відстрочки',
    description: 'Аналіз підстав (навчання, інвалідність, догляд), збір необхідного пакета документів та подання заяви до ТЦК.',
    price: 'від 2500 грн'
  }],
  bankruptcy: [{
    icon: <Scale size={24} strokeWidth={1.5} data-id="element-137" />,
    title: 'Банкрутство фізичних осіб',
    description: 'Повне законне списання кредитів, мікрозаймів (МФО) та комунальних боргів через судову процедуру.',
    price: 'від 15 000 грн'
  }, {
    icon: <ShieldAlert size={24} strokeWidth={1.5} data-id="element-138" />,
    title: 'Захист від колекторів',
    description: 'Припинення тиску, дзвінків та погроз. Блокування неправомірних дій колекторських компаній.',
    price: 'від 2000 грн'
  }, {
    icon: <Unlock size={24} strokeWidth={1.5} data-id="element-139" />,
    title: 'Зняття арештів з майна',
    description: 'Скасування виконавчих написів нотаріусів, закриття виконавчих проваджень та розблокування карткових рахунків.',
    price: 'від 3500 грн'
  }],
  family: [{
    icon: <HeartCrack size={24} strokeWidth={1.5} data-id="element-140" />,
    title: 'Розірвання шлюбу',
    description: 'Розлучення через суд або РАЦС, в тому числі дистанційно (якщо один із подружжя перебуває за кордоном).',
    price: 'від 2000 грн'
  }, {
    icon: <Users size={24} strokeWidth={1.5} data-id="element-141" />,
    title: 'Поділ спільного майна',
    description: "Судовий та позасудовий поділ нерухомості, автомобілів, бізнесу та боргових зобов'язань подружжя.",
    price: 'від 5000 грн'
  }, {
    icon: <Baby size={24} strokeWidth={1.5} data-id="element-142" />,
    title: 'Аліменти та опіка',
    description: 'Стягнення аліментів, визначення місця проживання дитини, отримання дозволу на виїзд дитини за кордон.',
    price: 'від 2500 грн'
  }],
  inheritance: [{
    icon: <ScrollText size={24} strokeWidth={1.5} data-id="element-143" />,
    title: 'Оформлення спадщини',
    description: 'Комплексний супровід відкриття та отримання спадщини у нотаріуса (за заповітом або за законом).',
    price: 'від 3000 грн'
  }, {
    icon: <Gavel size={24} strokeWidth={1.5} data-id="element-144" />,
    title: 'Спори між спадкоємцями',
    description: 'Визнання заповіту недійсним, зміна черговості спадкування, збільшення частки у судовому порядку.',
    price: 'від 6000 грн'
  }, {
    icon: <History size={24} strokeWidth={1.5} data-id="element-145" />,
    title: 'Поновлення строків',
    description: 'Судове поновлення пропущеного 6-місячного строку для прийняття спадщини з поважних причин.',
    price: 'від 4000 грн'
  }]
};
export function Services() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  return <section id="services" className="py-24 bg-surface" data-id="element-146">
      <div className="max-w-7xl mx-auto px-6" data-id="element-147">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-semibold mb-8" data-id="element-149">
            Наші послуги
          </h2>

          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-2 bg-background p-1.5 rounded-2xl border border-border inline-flex" data-id="element-150">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${activeTab === tab.id ? 'bg-primary text-background shadow-sm' : 'text-secondary hover:text-primary hover:bg-border/50'}`} data-id="element-151">
                {tab.label}
              </button>)}
          </div>
        </div>

        <div className="min-h-[400px]" data-id="element-152">
          <AnimatePresence mode="wait" data-id="element-153">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-154">
              {servicesData[activeTab as keyof typeof servicesData].map((service, index) => <div key={index} className="group bg-background rounded-3xl border border-border p-8 hover:border-primary/30 transition-colors duration-300 flex flex-col h-full" data-id="element-155">
                    <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-156">
                      {service.icon}
                    </div>

                    <h3 className="text-xl font-semibold mb-3" data-id="element-157">
                      {service.title}
                    </h3>

                    <p className="text-secondary text-sm leading-relaxed mb-8 flex-grow" data-id="element-158">
                      {service.description}
                    </p>

                    <div className="mb-6 pt-5 border-t border-border" data-id="element-159">
                      <div className="text-xs text-secondary uppercase tracking-wider mb-1 font-medium" data-id="element-160">
                        Вартість послуги
                      </div>
                      <div className="text-xl font-semibold text-primary" data-id="element-161">
                        {service.price}
                      </div>
                    </div>

                    <a href="#contact" className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center justify-center text-sm" data-id="element-162">
                      Безкоштовна консультація
                    </a>
                  </div>)}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-12 text-center" data-id="element-163">
          <a href="#contact" className="text-sm font-medium text-secondary hover:text-primary transition-colors underline underline-offset-4" data-id="element-164">
            Показати всі послуги практики
          </a>
        </div>
      </div>
    </section>;
}